import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { CircleHelp } from "lucide-react";
import { HiCheckCircle } from "react-icons/hi";

export function InstructionModal() {

    return (
        <>

            <Dialog>
                <DialogTrigger asChild>
                    <button data-tooltip-content={'How to use?'} data-tooltip-id="tooltip">
                        <CircleHelp className="size-5" />
                    </button>
                </DialogTrigger>
                <DialogContent className="z-[999]">
                    <DialogHeader>
                        <DialogTitle>How to Use?</DialogTitle>
                    </DialogHeader>
                    <div className="max-h-96 overflow-y-auto text-sm">
                        <div className="flex flex-col">
                            <span className="my-1">
                                Just write your prompt in the input field and click on the
                                generate button. That&apos;s it!
                            </span>
                            <span className="my-1">
                                You can customize the front, back, and the sleeves of the
                                t-shirt. You can select up to 4 images each to be printed
                                on the front and back side. For sleeves, you can only
                                select one image per sleeve.
                            </span>
                            <h2 className="mt-3 text-lg font-bold dark:text-white">
                                Example Prompts
                            </h2>
                            <span className="text-sm dark:text-slate-300">
                                Let&apos;s take a look at good and bad prompts.
                            </span>
                            <div className="my-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div>
                                    <h4 className="font-bold text-green-500 underline">
                                        Good Prompts
                                    </h4>
                                    <ul className="my-6 ml-6 list-decimal [&>li]:mt-2 text-slate-500 dark:text-slate-400">
                                        <li className="text-green-600 dark:text-green-500">
                                            Prompts of Animals doing something, somewhere
                                            <ul className="my-6 ml-6 list-disc [&>li]:mt-2 text-green-600 dark:text-green-500">
                                                <li>&quot;Gangster monkey, smoking a cigar on a beach&quot;</li>
                                                <li>&quot;Cute crocodile, smiling in a desert&quot;</li>
                                                <li>&quot;Polar bear, playing chess in a snowstorm&quot;</li>
                                            </ul>
                                        </li>
                                        <li className="text-green-600 dark:text-green-500">
                                            Extremely Popular Anime/Movie characters
                                            <ul className="my-6 ml-6 list-disc [&>li]:mt-2 text-green-600 dark:text-green-500">
                                                <li>&quot;Hulk, screaming in a forest&quot;</li>
                                                <li>
                                                    &quot;Luffy, a boy wearing a straw hat&quot;{" "}
                                                    <span className="text-sm text-slate-500">
                                                        If the model doesn&apos;t work properly, try
                                                        defining the distinctive physical
                                                        characteristics
                                                    </span>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="text-green-600 dark:text-green-500">
                                            Any general character
                                            <ul className="my-6 ml-6 list-disc [&>li]:mt-2 text-green-600 dark:text-green-500">
                                                <li>&quot;Astronaut meeting an alien&quot;</li>
                                                <li>&quot;White haired girl riding a horse&quot;</li>
                                            </ul>
                                        </li>
                                        <li className="text-green-600 dark:text-green-500 flex items-center">
                                            <HiCheckCircle className="mr-2" />
                                            Shorter prompts work better
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <h4 className="font-bold text-red-500 underline">
                                        Bad Prompts
                                    </h4>
                                    <ul className="my-6 ml-6 list-decimal [&>li]:mt-2 text-red-500">
                                        <li>
                                            Text within Image
                                            <ul className="my-6 ml-6 list-disc [&>li]:mt-2 text-red-500">
                                                <li>&quot;Iron man saying &apos;I am Iron Man&apos;&quot;</li>
                                                <li>&quot;Luffy saying &apos;I will be the Pirate King&apos;&quot;</li>
                                            </ul>
                                        </li>
                                        <li>
                                            Minor celebrities / characters
                                            <ul className="my-6 ml-6 list-disc [&>li]:mt-2 text-red-500">
                                                <li>&quot;Tom Cruise in a forest&quot;</li>
                                                <li>&quot;Pikachu in a desert&quot;</li>
                                            </ul>
                                        </li>
                                        <li>
                                            A group of people/characters
                                            <ul className="my-6 ml-6 list-disc [&>li]:mt-2 text-red-500">
                                                <li>&quot;Avengers playing football&quot;</li>
                                                <li>&quot;Justice League having a picnic&quot;</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            That&apos;s all you need to know for now. Get started below!
                        </div>
                    </div>
                    <DialogFooter className="pb-2">
                        <DialogClose>

                            <Button variant="default" className="w-full">
                                Close
                            </Button>
                        </DialogClose>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
}
